import ThemeToggle from "@/components/ThemeToggle";

/**
 * Fixed-position theme toggle for stand-alone (non-AppLayout) pages.
 * Sits in the top-right; safe across mobile + desktop breakpoints.
 */
export default function FloatingThemeToggle() {
  return (
    <div className="fixed top-3 right-3 z-50">
      <ThemeToggle className="bg-background/70 backdrop-blur border border-border shadow-sm" />
    </div>
  );
}
